




















import { Component, Vue, Watch } from 'vue-property-decorator';

import ListCard from '@/components/list-cards/ListCard.vue';
import SmallItemCard from '@/components/item-cards/SmallItemCard.vue';

import { ListModelUtil } from '@/model-utils/list-model-util';
import { ListSaveActions } from '@/actions/list-save-actions';
import { ItemStarActions } from '@/actions/item-star-actions';

import { ListModel } from '@/models/list-model';
import { UserModule, UserStore } from '../store/modules/user';
import { AbstractItemModel } from '../models/items/abstract-item-model';

@Component({
  components: {
    ListCard,
    SmallItemCard
  }
})
export default class MyCollection extends Vue {
  savedLists: ListModel[] = [];
  starredItems: AbstractItemModel[] = [];

  async updateLists() {
    this.savedLists = await ListModelUtil.hydrateLists(UserModule.savedListIds);
  }

  async updateItems() {
    this.starredItems = await ItemStarActions.getStarredItemsForUser(
      UserModule.currentUserId
    );
  }

  public mounted() {
    if (UserModule.currentUserId) {
      this.updateLists();
      this.updateItems();
    }

    this.$store.subscribe((mutation, state: any) => {
      if (mutation.type === UserStore.SET_SAVED_LIST_IDS_MUTATION) {
        this.updateLists();
      }
      if (mutation.type === UserStore.SET_STARRED_ITEM_IDS_MUTATION) {
        this.updateItems();
      }
    });
  }
}
